import { on as r, off as o } from "../../../../evtd@0.2.4/node_modules/evtd/es/delegate.js";
const d = "@@coContext", u = {
  mounted(t, { value: c, modifiers: e }) {
    t[d] = {
      handler: void 0
    }, typeof c == "function" && (t[d].handler = c, r("clickoutside", t, c, {
      capture: e.capture
    }));
  },
  updated(t, { value: c, modifiers: e }) {
    const n = t[d];
    typeof c == "function" ? n.handler ? n.handler !== c && (o("clickoutside", t, n.handler, {
      capture: e.capture
    }), n.handler = c, r("clickoutside", t, c, {
      capture: e.capture
    })) : (t[d].handler = c, r("clickoutside", t, c, {
      capture: e.capture
    })) : n.handler && (o("clickoutside", t, n.handler, {
      capture: e.capture
    }), n.handler = void 0);
  },
  unmounted(t, { modifiers: c }) {
    const { handler: e } = t[d];
    e && o("clickoutside", t, e, {
      capture: c.capture
    }), t[d].handler = void 0;
  }
}, a = u;
export {
  a as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/vdirs@0.1.8_vue@3.5.18/~/vdirs/es/clickoutside.js
// module id = 183
// module chunks = 67